import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import NetworkServiceModel      from '@/models/NetworkServiceModel';

@model.urnResource('relation_request_target_response_status')
@doc.path('/relation_request_target_response_statuses/{?id}')
export default class RelationRequestTargetResponseStatusModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
		"reference": RelationRequestTargetResponseStatusReference;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	get reference(): RelationRequestTargetResponseStatusReference {
		return this.get('reference');
	}

	public get color() {
		switch (this.reference) {
			case 'accepted':
				return 'green';
			case 'refused':
				return 'red';
			case 'pending':
				return 'orange';
		}
	}
}